import React, { useState } from 'react';
import UserPicker from '../../components/ui/UserPicker';
import { EmptyState } from '../../components/ui/PanelCard';
import { useUserRoutes, UserRoutesCard, RouteSharingCard } from './UserRoutesCards';

/**
 * Staff › Route moderation (2026-10-07) — egy játékos route-jai és megosztásai. A Codex adminjának felhasználó-
 * lapjáról költözött ide, amikor a bot felülete külön projekt lett: a fiók kezelése (tiltás, HWID, előfizetés) a
 * Codex oldalon maradt, a route-ok a bot oldalán vannak.
 * Ki mit lát (cloud route terv 7.4): a megosztott route-okat az admin is, a privát route-okat és a szövegüket csak
 * az owner — a backend dönt, a felület csak kiírja. Minden művelet az audit-naplóba megy (a Codex adminjában látszik).
 */
export default function ModerationTab() {
  const [picked, setPicked] = useState(null);

  return (
    <div className="flex flex-col gap-6">
      <div className="max-w-[460px]">
        <UserPicker value={picked} onChange={setPicked} placeholder="Search by username…" />
      </div>
      {picked
        ? <UserRoutes key={picked.id} userId={picked.id} />
        : <EmptyState title="Pick a player" hint="Their routes, share codes and library listings show up here." />}
    </div>
  );
}

function UserRoutes({ userId }) {
  const routes = useUserRoutes(userId);
  return (
    <div className="grid gap-6 min-[1100px]:grid-cols-[minmax(0,1fr)_380px] items-start">
      <UserRoutesCard state={routes} />
      <RouteSharingCard state={routes} userId={userId} />
    </div>
  );
}
